<template>
  <div class="salientDoctor">
    <div class="salientDoctor_center">
      <!--选择-->
      <div v-if="0" class="diseaseList_selectCentre">
        <!--一级科室-->
        <div class="oneDepartment">
          <div class="title">一级科室</div>
          <div class="oneDepartment_list">
            <div class="item_list">内科</div>
            <div class="item_list">外科</div>
            <div class="item_list">妇产科</div>
            <div class="item_list">儿科</div>
            <div class="item_list">男性科</div>
            <div class="item_list">无官科</div>
            <div class="item_list">皮肤性病科</div>
            <div class="item_list">肿瘤科</div>
            <div class="item_list">不孕不育科</div>
            <div class="item_list">其他</div>
          </div>
        </div>
        <!--二级科室-->
        <div class="twoDepartment">
          <div class="title">二级科室</div>
          <div class="twoDepartment_list">
            <div class="item_list">内科</div>
            <div class="item_list">外科</div>
            <div class="item_list">妇产科</div>
            <div class="item_list">儿科</div>
            <div class="item_list">男性科</div>
            <div class="item_list">无官科</div>
            <div class="item_list">皮肤性病科</div>
            <div class="item_list">肿瘤科</div>
            <div class="item_list">不孕不育科</div>
            <div class="item_list">其他</div>
          </div>
        </div>
      </div>
      <!--列表-->
      <div class="recommend_box">
        <div class="swiper_listBox" v-for="item in doctorData" :key="item.doctorId" @click="handleGoShow(item.doctorId)">
          <!--上-->
          <div class="slide_top">
            <img :src="item.headImage" alt="">
          </div>
          <!--中-->
          <div class="slide_center">
            <div class="user_name">
              <div>{{item.doctorName}}</div>
              <span>{{item.doctorLevelName}}</span>
            </div>
            <div class="user_title">
              <div>{{item.hospitalName}}</div>
              <span>{{item.departmentName}}</span>
            </div>
          </div>
          <!--下-->
          <div class="slide_bottom">
            <div class="top_box">
              <div class="video">
                <img width="24px" height="20px" src="../../../assets/images/home/u4279.png" alt="">
                <div class="title">视频</div>
                <div class="num">{{item.videoCount}}</div>
              </div>
              <div class="mask"></div>
              <div class="voice">
                <img width="24" height="23px" src="../../../assets/images/home/u10222.png" alt="">
                <div class="title">音频</div>
                <div class="num">{{item.voiceCount}}</div>
              </div>
              <div class="mask"></div>
              <div class="text">
                <img width="19px" height="20px"  src="../../../assets/images/home/u4294.png" alt="">
                <div class="title">问答</div>
                <div class="num">{{item.askCount}}</div>
              </div>
            </div>
            <div class="chaKan">查看</div>
          </div>
        </div>
      </div>
      <!--分页-->
      <Pagination  :pageSize="total" v-model="dataForm.page" @on-jump="jump" />
    </div>
  </div>
</template>

<script>
  import Pagination from '../../../components/pagination/index'
  export default {
    name: "List",
    components:{
      Pagination
    },
    data() {
      return {
        total:10,
        dataForm:{
          page:1,
          size:15,
        },
        doctorData:[],
      }
    },
    methods:{
      jump(page){
        this.dataForm.page = page
        this.getDoctorList()
      },
      handleGoShow(id){
        this.$router.push({path:'/tt/salientDoctor/salientDoctorShow/'+id+'.html',query:{}})
      },
      // 获取医生列表
      getDoctorList() {
        let params = {
          page:this.dataForm.page,
          size:this.dataForm.size,
        }
        this.$api.mykp_home.findDoctorTree(params) .then(res => {
          if(res.code == '000000') {
            this.doctorData = res.infos.list
            this.total = Math.ceil(res.infos.total/15)
          }
        })
      },
    },
    activated() {
      this.getDoctorList()
    }
  }
</script>
<style lang="stylus" scoped>
  .salientDoctor{
    .salientDoctor_center{
      width: 1200px
      margin 0 auto
      .diseaseList_selectCentre{
        margin-top 20px
        border 1px solid #eee
        border-radius: 9px;
        padding 20px 20px 10px 20px
        .oneDepartment{
          display flex
          flex-wrap wrap
          align-items center
          min-height 60px
          &:after{
            content ''
            display block
            height: 1px
            width 100%
            border-top 1px dashed #eee
            margin 10px  10px 0 10px
          }
          .title{
            font-weight: 700;
            font-style: normal;
            font-size: 16px;
            color: #333
            margin-right 20px
          }
          .oneDepartment_list{
            flex 1
            display flex
            flex-wrap wrap
            .item_list{
              font-size: 14px;
              color: #333
              margin-right 20px
              padding 10px 0
              cursor: pointer
            }
          }
        }
        .twoDepartment{
          display flex
          flex-wrap wrap
          align-items center
          min-height 60px
          .title{
            font-weight: 700;
            font-style: normal;
            font-size: 16px;
            color: #333
            margin-right 20px
          }
          .twoDepartment_list{
            flex 1
            display flex
            flex-wrap wrap
            .item_list{
              font-size: 14px;
              color: #333
              margin-right 20px
              padding 10px 0
              cursor: pointer
            }
          }
        }
      }

      // 专家推荐
      .recommend_box{
        display flex
        flex-wrap wrap
        margin-bottom 30px
        margin-top 30px
        .swiper_listBox{
          cursor: pointer
          margin-right 25px
          margin-bottom 20px
          width: 218px;
          height: 473px;
          display flex
          flex-direction column
          align-items center
          justify-content space-around
          border:1px solid #e4e4e4
          border-radius: 7px;
          &:nth-child(5n){
            margin-right 0px
          }
          &:hover{
            border-color: #1083f8
          }
          .slide_top{
            width: 200px
            height: 200px
            background #f2f2f2
            border-radius 50%
            display flex
            align-items center
            justify-content center
            >img{
              width: 180px
              height: 180px
              border-radius 50%
            }
          }
          .slide_center{
            display flex
            flex-direction column
            align-items center
            &:after{
              content:''
              display block
              width: 100%
              height: 1px
              border-top:1px solid #eee
              margin 20px 0
            }
            .user_name{
              /*margin-top 10px*/
              display flex
              align-items center
              >div{
                font-weight: 700;
                font-size: 18px;
                color: #000000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width 65px
                margin-right 10px
              }
              >span{
                font-size: 16px;
                color #fff
                width: 85px;
                height: 31px;
                background #1083f8
                display block
                text-align: center
                line-height 31px
                border-radius: 5px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .user_title{
              margin-top 20px
              display flex
              align-items center
              >div{
                width: 100px
                font-size: 14px;
                color: #000000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              >span{
                width: 100px
                display block
                font-size: 14px;
                color: #000000;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .slide_bottom{
            .top_box{
              display flex
              align-items center
              justify-content space-around
              width: 200px
              margin-bottom 20px
              .video,.voice,.text{
                display flex
                flex-direction column
                align-items center
                >img{

                }
                .title{
                  font-size: 16px;
                  color: #A1A1A1;
                  margin 10px 0 5px 0
                }
                .num{
                  font-size: 18px;
                  color: #8CD4A7;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width 50px
                }
              }
              .mask{
                height: 60px
                width: 1px
                background #eee
              }
            }
            .chaKan{
              margin 0 auto
              width: 68px;
              height: 25px;
              border 1px solid #199ed8
              color: #199ed8
              border-radius: 5px;
              text-align: center
              line-height 25px
              cursor: pointer
            }
          }
        }
      }
    }
  }

  // 轮播区
  .home_swiper{
    width 1200px
    margin 0 auto
    // 轮播
    .swiper-container {
      margin-top 20px
      width:100%
      height 350px
      .swiper-slide{
        cursor: pointer
      }
      img{
        width 100%
        height 100%
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/view-tt/salientDoctor/List.vue